import React from "react";
import "./Footer.css";

const Footer = () => {
  return (
    <footer className="lg:px-40 px-4 bg-gray-900 text-white py-8">
      <div className="container mx-auto flex flex-col md:flex-row justify-between items-start">
        {/* Company Logo */}
        <div className="mb-4 md:mb-0 animate-fade-in">
          <p className="text-lg font-bold">PAWAN KAAZ</p>
        </div>

        {/* Company Links */}
        <div className="mb-4 md:mb-0 md:ml-8 animate-fade-in">
          <h4 className="text-lg font-bold mb-2">COMPANY</h4>
          <ul>
            <li className="mb-2">
              <a href="#" className="hover:text-gray-300">
                Services
              </a>
            </li>
            <li className="mb-2">
              <a href="#" className="hover:text-gray-300">
                Pricing
              </a>
            </li>
            <li>
              <a href="#" className="hover:text-gray-300">
                Docs
              </a>
            </li>
          </ul>
        </div>

        {/* Resources Links */}
        {/* <div className="mb-4 md:mb-0 md:ml-8 animate-fade-in">
          <h4 className="text-lg font-bold mb-2">RESOURCES</h4>
          <ul>
            <li className="mb-2">
              <a href="#" className="hover:text-gray-300">
                Blog post name list goes here
              </a>
            </li>
            <li className="mb-2">
              <a href="#" className="hover:text-gray-300">
                Blog post name list goes here
              </a>
            </li>
            <li className="mb-2">
              <a href="#" className="hover:text-gray-300">
                Blog post name list goes here
              </a>
            </li>
            <li>
              <a href="#" className="hover:text-gray-300">
                See all resources &gt;
              </a>
            </li>
          </ul>
        </div> */}

        {/* About Links */}
        <div className="mb-4 md:mb-0 md:ml-8 animate-fade-in">
          <h4 className="text-lg font-bold mb-2">ABOUT</h4>
          <ul>
            <li className="mb-2">
              <a href="#" className="hover:text-gray-300">
                Terms & Conditions
              </a>
            </li>
            <li>
              <a href="#" className="hover:text-gray-300">
                Privacy policy
              </a>
            </li>
          </ul>
        </div>

        {/* Social Media Icons */}
        <div className="flex space-x-4 animate-fade-in">
          <a href="#" className="text-gray-300 hover:text-white">
            <span className="sr-only">Twitter</span>
            <svg className="w-6 h-6" fill="currentColor" viewBox="0 0 24 24">
              <path d="M24 4.557a9.828 9.828 0 01-2.828.775 4.932 4.932 0 002.165-2.014 9.84 9.84 0 01-3.127 1.195 4.92 4.92 0 00-8.452 4.988 13.977 13.977 0 01-7.776-4.2 4.927 4.927 0 001.167 2.014 9.828 9.828 0 01-2.828-.775A14.947 14.947 0 002.458 7.833c1.351 4.65 6.588 8.118 12.234 8.118 6.609 0 11.907-3.868 12.912-9.228a14.82 14.82 0 00-.435-2.246z"></path>
            </svg>
          </a>
          <a href="#" className="text-gray-300 hover:text-white">
            <span className="sr-only">LinkedIn</span>
            <svg className="w-6 h-6" fill="currentColor" viewBox="0 0 24 24">
              <path d="M22.234 0H1.766C.762 0 0 .763 0 1.767v20.466C0 23.238.762 24 1.766 24h20.468C23.238 24 24 23.238 24 22.234V1.767C24 .762 23.238 0 22.234 0zM9.334 21H4.07V9.885h1.653V13.997h2.612V9.885h1.654V21zm-5.6-7.189c-1.627 0-2.545-1.54-1.795-2.876.43-.79.795-1.408 1.367-2.013.79-.79.79-.795 1.588-.795s1.653.79 1.653 1.968c0 1.227-.808 2.013-1.653 2.013-.698 0-1.226-.33-1.588-.795-.372-.487-.795-.808-1.367-1.408-.79-.795-1.708-1.227-2.545-1.227-.972 0-1.889.43-2.545 1.227-.657.79-.987 1.778-.987 2.876 0 1.542.91 2.877 2.545 2.877z"></path>
            </svg>
          </a>
          <a href="#" className="text-gray-300 hover:text-white">
            <span className="sr-only">Facebook</span>
            <svg className="w-6 h-6" fill="currentColor" viewBox="0 0 24 24">
              <path d="M22.675 0H1.327C.593 0 0 .589 0 1.319v21.365C0 23.411.593 24 1.327 24H12.82v-9.203h-3.602v-3.812h3.602v-2.671c0-3.102 1.893-4.788 4.659-4.788 1.325 0 2.464.099 2.797.144v3.24h-1.92c-1.504 0-1.795.715-1.795 1.764v2.313h3.588l-.467 3.812h-3.12V24h6.116c.734 0 1.326-.593 1.326-1.327V1.327c0-.73-.593-1.327-1.327-1.327z"></path>
            </svg>
          </a>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
